import {Controller} from "@hotwired/stimulus";

// Connects to data-controller="number-field"
export default class extends Controller {
  static targets = ["inputField"];

  static values = {
    positiveField: Boolean,
    max: String,
    type: String, default: 'float' // 'float' or 'integer'
  };

  connect() {
    this.inputFieldTarget.addEventListener("input", this.positiveFieldValue ? this.filterPositiveInput : this.filterNegativeInput);
  }

  filterPositiveInput = (event) => {
    let value = event.target.value
      .replace(/[^\d.]/g, "") // Remove non-digits and non-decimal points
      .replace(/^0+(?=\d)/, "") // Remove leading zeros
      .replace(/^\./, "0.") // Add leading zero if starts with decimal
      .replace(/\.(?=.*\.)/g, ""); // Keep only first decimal point

    event.target.value = this.commonFilters(value)
  };

  filterNegativeInput = (event) => {
    let value = event.target.value
      .replace(/[^\d.-]/g, "") // Remove non-digits, non-decimal points, non-negative signs
      .replace(/^-{2,}/g, "-") // Keep only first negative sign
      .replace(/^(-)?0+(?=\d)/, "$1") // Remove leading zeros but keep negative sign
      .replace(/^(-)?\./, "$10.") // Add leading zero if starts with decimal
      .replace(/\.(?=.*\.)/g, "") // Keep only first decimal point
      .replace(/^(-)?(-)+/, "-") // Keep only first negative sign
      .replace(/(?!^)-/g, ""); // Remove negative signs not at start


    event.target.value = this.commonFilters(value)
  }

  commonFilters(value) {
    // Limit to 2 decimal places
    if (value.includes('.')) {
      const parts = value.split('.')
      if (parts[1].length > 2) value = `${parts[0]}.${parts[1].slice(0, 2)}`
    }

    // Convert to number for max value check
    const numValue = parseFloat(value)
    if (this.maxValue != '' && !isNaN(numValue) && numValue > parseFloat(this.maxValue)) value = this.maxValue.toString()

    // If type is integer, remove decimal part
    if (this.typeValue === 'integer') value = value.split('.')[0]

    return value
  }
}
